import "../App.css";
import { resetFeedFilter } from "../redux/actions";
import { useAppDispatch } from "../redux/store/hooks";
import Experts from "../components/Experts";
import { InfoCircleOutlined } from "@ant-design/icons";
import { StructureGraph } from "../components/StructureGraph/graphComponent";

function ExpertsFull() {
  const dispatch = useAppDispatch();
  dispatch(resetFeedFilter());

  return (
    <div className="App">
      <StructureGraph/>
      
      <Experts />
    </div>
  );
}

export default ExpertsFull;
